<template>
  <portal to="globalDialog">
    <ui-dialog
      rounded-border
      v-if="show"
      :style="`z-index: ${maxZIndex + 100} !important;`"
      @close="$emit('close')"
    >
      <ui-info-content icon-background="gray" class="SlcAlertDialog-container">
        <ui-icon
          style="color: var(--color-grey-80);"
          slot="icon"
          :name="iconName"
          size="xl"
        />

        <span slot="title"><slot name="title"></slot></span>

        <p>
          <slot name="message"></slot>
        </p>
        <br />
        <p>
          <a class="SlcAlertDialog-link" href="tel:+49040411332600"
            >040/4113-32600</a
          >
          oder
          <a
            class="SlcAlertDialog-link"
            href="mailto: kundenservice.desk@dpa.com"
            >kundenservice.desk@dpa.com</a
          >
        </p>
      </ui-info-content>
    </ui-dialog>
  </portal>
</template>

<script>
import { defineComponent } from "vue";
import UiDialog from "@dpa-id-components/ui-dialog";
import "@dpa-id-components/ui-dialog/dist/UiDialog.css";
import UiInfoContent from "@dpa-id-components/ui-info-content";
import "@dpa-id-components/ui-info-content/dist/UiInfoContent.css";
import UiIcon from "@dpa-id-components/ui-icon";
import "@dpa-id-components/ui-icon/dist/UiIcon.css";
import maxZIndex from "@/views/lib/useMaxZIndex";

export default defineComponent({
  components: { UiDialog, UiInfoContent, UiIcon },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    iconName: {
      typ: String,
      default: "alert"
    }
  },
  setup() {
    return { maxZIndex };
  }
});
</script>

<style scoped>
.SlcAlertDialog-container {
  margin: 16px 0 48px 0;
}

.SlcAlertDialog-link {
  color: var(--color-blue);
  font-weight: 600;
}
</style>
